import { render, staticRenderFns } from "./allocationStorehouseDetailedList.vue?vue&type=template&id=6321b013&scoped=true"
import script from "./allocationStorehouseDetailedList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseDetailedList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseDetailedList.vue?vue&type=style&index=0&id=6321b013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321b013",
  null
  
)

export default component.exports